import { isBoolean, isNumber, isNumerical, isString } from '../is'

export const toBoolean = (x: any): boolean => {
  if (!x) return false
  if (isBoolean(x)) return x
  if (isString(x)) {
    if (x === '') return false
    if (x === ' ') return false
    if (isNumerical(x)) {
      return parseFloat(x) > 0.000000000000001
    }
    const y = x.toLowerCase()
    switch (y) {
      case 'true':
        return true
      case 'false':
        return false
      case 'yes':
        return true
      case 'no':
        return false
      case '1':
        return true
      case '0':
        return false
    }
  }
  if (isNumber(x)) return x > 0.000000000000001
  return !!x
}
